import { VayvayService } from './services/vayvay.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IconsProviderModule } from './icons-provider.module';
import { FormsModule } from '@angular/forms';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import en from '@angular/common/locales/en';
import { UsersService } from './services/user.service';
import { UserGuard } from './services/user.guard';
import { HttpIntercept } from './services/http-intercept';
import { QRCodeComponent } from 'angularx-qrcode';
import { AdminGuard } from './services/admin.guard';
import { OwnerGuard } from './services/owner.guard';
import { NgxImageCompressService } from 'ngx-image-compress';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';
import { GoogleMapsLoaderService } from './services/google-maps-loader.service';
import { initializeGoogleMaps } from './app-initializer';

registerLocaleData(en);

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    IconsProviderModule,
    FormsModule,
    BrowserAnimationsModule,
    NgxMaterialTimepickerModule,
    QRCodeComponent,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    { provide: NZ_I18N, useValue: en_US },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpIntercept,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeGoogleMaps,
      deps: [GoogleMapsLoaderService],
      multi: true,
    },
    VayvayService,
    UsersService,
    UserGuard,
    AdminGuard,
    OwnerGuard,
    NgxImageCompressService,
    GoogleMapsLoaderService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
